export default "__VITE_ASSET__BpRhVh0i__"